import Wrapper from 'components/onboarding/wrapper'
import AnimatedLogo from 'components/utilities/animated-logo'
import { useOnboarding } from 'context/onboarding-context'
import useDebounce from 'hooks/use-debounce'
import { useMemo } from 'react'

const Building = () => {
  const { step, nextStep } = useOnboarding()
  const isVisible = useMemo(() => step === 1, [step])

  useDebounce(
    () => {
      if (!isVisible) {
        return
      }

      nextStep()
    },
    [isVisible],
    2500,
  )

  return (
    <Wrapper isVisible={step === 1}>
      <section className="flex flex-col gap-3">
        <div className="flex flex-col items-center gap-8 pb-9 pt-12">
          <AnimatedLogo className="size-28" fill="fill-gray-100" />
          <h1 className="flex flex-row flex-wrap items-center gap-1 text-4xl text-gray-300">
            Building your machining process...
          </h1>
        </div>
      </section>
    </Wrapper>
  )
}

export default Building
